import SiteShell from "../components/SiteShell";
import DiagramFlow from "../components/DiagramFlow";

const serviceCards = [
  {
    title: "Pilot Setup in Delhi NCR",
    text: "Rapid pilot installation for instant salaried personal loan journeys at selected points.",
    image:
      // "https://images.pexels.com/photos/37347/office-sitting-room-executive-sitting.jpg",
      "/Delhi.jpeg",
  },
  {
    title: "Multi-Location Rollout",
    text: "Expand from pilot to city-level and pan-India deployment with standardized kiosk configuration.",
    image: "https://images.pexels.com/photos/466685/pexels-photo-466685.jpeg",
  },
  {
    title: "Ongoing Operations Support",
    text: "Monitoring, field support and SLA-driven uptime for mission-critical loan processing.",
    image: "office1.jpeg",
  },
];

function Services() {
  return (
    <SiteShell
      route="services"
      heroTag="Partner with us "
      heroTitle="Partner with finncube and grow your business."
      // heroText="All NBFC's Banks and Fintech Companies are welcome to partner with us."
      heroText={
        <>
          All NBFC's, Banks and Fintech Companies are welcome to partner with us.{" "}
          <br />
          Contact us: <br />
          Phone: +91 9997842548 <br/>
          Email: care@finncube.com<br/>
          Our NBFC Partners: Pawansut Holding ltd.
        </>
      }
      heroImage="/partnerWith1.png"
      heroActions={[
        // { label: "Email us", href: "mailto:care@finncube.com", primary: true },
        // { label: "Plan Deployment", href: "#/company", primary: true },
        // { label: "View Architecture", href: "#/software" },
      ]}
    >
      <DiagramFlow
        title="Scaling Lifecycle"
        subtitle="A proven, multi-stage roadmap designed for rapid expansion while maintaining elite operational standards."
        steps={[
          {
            title: "Pilot Phase",
            text: "Targeted installation to baseline journey speed and conversion metrics.",
          },
          {
            title: "Validation",
            text: "Rigorous performance analysis and stability hardening.",
          },
          {
            title: "Grid Expansion",
            text: "Rapid rollout across high-density salaried hubs and corporate zones.",
          },
          {
            title: "SLA Support",
            text: "Continuous proactive monitoring and field engineering support.",
          },
        ]}
      />

      <section className="mx-auto max-w-[1280px] px-4 py-14 sm:px-6 sm:py-16 md:px-10 md:py-20">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-2xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-3xl md:text-5xl">
            Deployment Framework
          </h2>
          <p className="mt-4 text-sm text-slate-500 sm:mt-6 sm:text-base">
            We provide the technical and operational blueprint for scaling
            India's first dedicated 3-minute loan kiosk network.
          </p>
        </div>
        <div className="grid gap-8 md:grid-cols-3">
          {serviceCards.map((card) => (
            <article
              key={card.title}
              className="group overflow-hidden rounded-[32px] border border-slate-100 bg-white p-2 shadow-xl transition-all duration-500 hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden rounded-[24px] sm:h-56">
                <img
                  src={card.image}
                  alt={card.title}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="text-lg font-bold tracking-tight text-[#0a2c4f] sm:text-xl">
                  {card.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-500">
                  {card.text}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 pb-16 sm:px-6 sm:pb-20 md:px-10 md:pb-24">
        <div className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-2xl sm:rounded-[40px] sm:p-8 md:rounded-[48px] md:p-16">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
            <div>
              <p className="text-[15px] font-black uppercase tracking-[0.25em] text-[#e37921]">
                Operations
              </p>
              <h2 className="mt-4 text-2xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-3xl md:text-4xl">
                Coverage Blueprint
              </h2>
            </div>
            <p className="max-w-sm text-sm text-slate-500">
              Standardized protocols for consistent delivery across all
              geographical zones.
            </p>
          </div>
          <div className="grid gap-6 md:grid-cols-3">
            {[
              {
                zone: "Delhi NCR",
                text: "Execution HQ and primary performance testing zone.",
                label: "Zone 1",
              },
              {
                zone: "Metro Cities",
                text: "Dense salaried professional populations across NCR.",
                label: "Zone 2",
              },
              {
                zone: "National Scale",
                text: "Standardized deployment kits for pan-India expansion.",
                label: "Zone 3",
              },
            ].map((item) => (
              <article
                key={item.zone}
                className="group rounded-3xl bg-slate-50 p-8 transition-all hover:bg-white hover:shadow-xl"
              >
                <div className="inline-block px-3 py-1 rounded-full bg-navy/5 text-[#e37921] text-[15px] font-black uppercase tracking-widest">
                  {item.label}
                </div>
                <h3 className="mt-6 text-xl font-extrabold text-[#0a2c4f]">
                  {item.zone}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-500">
                  {item.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}

export default Services;
